import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import TopBanner from '@/components/back-office/TopBanner';
import BOLayout from '@/pages/back-office/BOLayout';
import axios from 'axios';
import Pen from '@/assets/media/SVGComponents/Pen';
import Trash from '@/assets/media/SVGComponents/Trash';
import { toast } from 'react-toastify';
import Modal from '@/components/Modal';
import Pagination from '@/components/back-office/Pagination';

const NotificationList = () => {
    const { restaurantId } = useParams();
    const [notifications, setNotifications] = useState([]);
    const role = JSON.parse(localStorage.getItem('role'));
    const [showModal, setShowModal] = useState(false);
    const [notificationId, setNotificationId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const notificationsPerPage = 10;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/notifications`);
                setNotifications(response.data);
            } catch (error) {
                toast.error('Erreur lors du chargement des notifications', {
                    position: 'top-center',
                    autoClose: 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    theme: 'colored',
                });
            }
        };
        fetchNotifications();
    }, [restaurantId]);

    const handleOpenModal = (notifId) => {
        setNotificationId(notifId);
        setShowModal(true);
    };

    const handleDelete = async () => {
        try {
            await axios.delete(`${import.meta.env.VITE_API_URL}/api/notifications/${notificationId}`);
            setNotifications(notifications.filter((notif) => notif.id !== notificationId));
            toast.success('Notification supprimée avec succès', {
                position: 'top-center',
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                theme: 'colored',
            });
        } catch (error) {
            toast.error('Erreur lors de la suppression de la notification', {
                position: 'top-center',
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                theme: 'colored',
            });
        }
        setShowModal(false);
    };

    const indexOfLastNotif = currentPage * notificationsPerPage;
    const indexOfFirstNotif = indexOfLastNotif - notificationsPerPage;
    const currentNotifications = notifications.slice(indexOfFirstNotif, indexOfLastNotif);

    const onPageChange = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <BOLayout>
            <div className="mb-4">
                <TopBanner
                    role={role}
                    showButtons={''}
                    navigationRouteText={'Créer une notification'}
                    navigationRoute={`/back-office/notifications/create`}
                    showToggle={false}
                    hasTopRightButton={['super-admin', 'admin'].includes(role)}
                />
            </div>

            {showModal && (
                <Modal
                    type={'danger'}
                    title={'Cette action est irréversible'}
                    setShowModal={setShowModal}
                    handleSubmit={handleDelete}
                />
            )}

            <table className="table table-striped table-bordered table-fixed w-full text-center">
                <thead className="border-b border-b-black pb-2 mb-4">
                    <tr>
                        <th>Nom</th>
                        <th>Type</th>
                        <th>Date de début</th>
                        <th>Date de fin</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentNotifications.map((notif) => (
                        <tr key={notif.id}>
                            <td>{notif.name}</td>
                            <td>{notif.type}</td>
                            <td>{notif.startDate}</td>
                            <td>{notif.endDate || 'N/A'}</td>
                            <td className="flex items-center justify-center gap-2">
                                <button
                                    type="button"
                                    onClick={() => navigate(`/back-office/notifications/${notif.id}/edit`)}
                                >
                                    <Pen color="#A2924A" width={40} height={40} />
                                </button>
                                <button
                                    type="button"
                                    className="m-2"
                                    onClick={() => handleOpenModal(notif.id)}
                                >
                                    <Trash color="#A2924A" width={40} height={40} />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <Pagination
                currentPage={currentPage}
                totalItems={notifications.length}
                itemsPerPage={notificationsPerPage}
                onPageChange={onPageChange}
            />
        </BOLayout>
    );
};

export default NotificationList;
